import React, { useEffect, useRef, useState } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { QRCodeSVG } from 'qrcode.react';

export function normalizeLabelNumber(value) {
  const match = String(value || '').trim().match(/^B?0*(\d{1,6})$/i);
  if (!match || Number(match[1]) < 1) return '';
  return `B${String(Number(match[1])).padStart(3, '0')}`;
}

export default function SingleLabelPrint({ initialNumber, onClose }) {
  const [number, setNumber] = useState(initialNumber || '');
  const [copies, setCopies] = useState(1);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const frame = useRef(null);
  const boxNumber = normalizeLabelNumber(number);
  const count = Number(copies);
  const valid = boxNumber && Number.isInteger(count) && count >= 1 && count <= 20;
  const url = boxNumber ? `${window.location.origin}/box/${boxNumber}` : '';
  useEffect(() => () => { if (frame.current) frame.current.remove(); }, []);

  async function print() {
    if (!valid || busy) return;
    setError('');
    setBusy(true);
    try {
      const svg = renderToStaticMarkup(<QRCodeSVG value={url} size={200} level="M" marginSize={4} />);
      const pages = Array.from({ length: count }, () => `<section class="label">${svg}<strong>${boxNumber}</strong></section>`).join('');
      const html = `<!doctype html><html lang="de"><head><meta charset="utf-8"><title>${boxNumber} – Brother 62 mm</title><style>
        @page { size: 90mm 62mm; margin: 0; }
        * { box-sizing: border-box; }
        html,body { margin: 0; padding: 0; background: white; color: black; }
        .label { width: 90mm; height: 62mm; padding: 4mm; display: flex; align-items: center; justify-content: space-between; break-after: page; page-break-after: always; overflow: hidden; }
        .label:last-child { break-after: auto; page-break-after: auto; }
        svg { display: block; width: 43mm; height: 43mm; flex-shrink: 0; }
        strong { width: 37mm; text-align: center; font: bold ${boxNumber.length > 5 ? '9' : '12'}mm Arial,sans-serif; }
      </style></head><body>${pages}</body></html>`;
      if (frame.current) frame.current.remove();
      const iframe = document.createElement('iframe');
      iframe.title = 'Etiketten-Druckansicht';
      iframe.style.cssText = 'position:fixed;left:-10000px;top:0;width:900px;height:620px;border:0';
      frame.current = iframe;
      const ready = new Promise((resolve, reject) => {
        iframe.onload = resolve;
        iframe.onerror = () => reject(new Error('Druckansicht konnte nicht geladen werden.'));
      });
      iframe.srcdoc = html;
      document.body.appendChild(iframe);
      await ready;
      await iframe.contentDocument.fonts.ready;
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    } catch (printError) {
      setError(printError.message || 'Druckdialog konnte nicht geöffnet werden.');
    } finally { setBusy(false); }
  }

  return <div className="single-label-overlay">
    <section className="single-label-dialog" role="dialog" aria-modal="true" aria-labelledby="single-label-title">
      <button className="single-label-close" onClick={onClose} aria-label="Schließen">×</button>
      <h2 id="single-label-title">Einzelne Boxenetiketten</h2>
      <p>Brother · 62-mm-Endlosrolle · Querformat 90 × 62 mm</p>
      <div className="single-label-fields">
        <label>Boxnummer<input autoFocus value={number} onChange={event => setNumber(event.target.value)} placeholder="z. B. 20 oder B020" maxLength={10} /></label>
        <label>Stückzahl<input type="number" min="1" max="20" value={copies} onChange={event => setCopies(event.target.value)} /></label>
      </div>
      {boxNumber && <div className="single-label-preview" aria-label={`Etikettenvorschau ${boxNumber}`}>
        <QRCodeSVG value={url} size={160} level="M" marginSize={4} />
        <strong style={{fontSize: boxNumber.length > 5 ? '28px' : undefined}}>{boxNumber}</strong>
      </div>}
      <p className="single-label-hint">Im Druckdialog: Brother QL-820NWB, Papier „62mm“, Querformat, 100 %, keine Ränder und keine Kopf-/Fußzeilen. Kopien dort auf 1 lassen – die gewählte Stückzahl ist bereits enthalten.</p>
      <p className="single-label-hint">Nachdrucke sind möglich. Es wird keine neue Box angelegt und der A4-Druckstand bleibt unverändert.</p>
      {error && <p role="alert">{error}</p>}
      <button className="app-button app-button-primary" disabled={!valid || busy} onClick={print}>
        {busy ? 'Druckansicht wird vorbereitet…' : 'Druckdialog öffnen'}
      </button>
    </section>
  </div>;
}
